import type { SVGProps } from "react";
import * as React from "react";
const SvgGitlab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#E24329"
      d="m21.797 9.625-.028-.072-2.722-7.103a.718.718 0 0 0-1.36.074L15.85 8.15H8.413L6.575 2.524a.715.715 0 0 0-1.08-.411.703.703 0 0 0-.28.337L2.493 9.553l-.027.072a5.055 5.055 0 0 0 1.677 5.841l.01.007.023.018 4.147 3.105 2.051 1.553 1.248.943c.301.228.717.228 1.018 0l1.248-.943 2.05-1.553 4.172-3.123.01-.008a5.055 5.055 0 0 0 1.677-5.84Z"
    />
    <path
      fill="#FC6D26"
      d="m21.796 9.625-.027-.072a9.194 9.194 0 0 0-3.66 1.646l-5.978 4.52 3.807 2.877 4.172-3.123.01-.008a5.055 5.055 0 0 0 1.676-5.84Z"
    />
    <path
      fill="#FCA326"
      d="m8.323 18.596 2.051 1.553 1.248.943c.301.228.717.228 1.018 0l1.248-.943 2.05-1.553-3.807-2.877-3.808 2.877Z"
    />
    <path
      fill="#FC6D26"
      d="M6.152 11.199a9.187 9.187 0 0 0-3.659-1.646l-.027.072a5.055 5.055 0 0 0 1.677 5.841l.01.007.023.019 4.147 3.104 3.808-2.877c-2.741-2.073-5.961-4.508-5.979-4.52Z"
    />
  </svg>
);
export default SvgGitlab;
